import { render } from "./Notes.vue?vue&type=template&id=12ac0705&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=12ac0705&scoped=true&lang=css"
import "./Notes.vue?vue&type=style&index=1&id=12ac0705&scoped=true&lang=css"

import exportComponent from "D:\\project\\vue\\family-notes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ac0705"]])

export default __exports__